/**
 * Icon Map - 后端菜单 icon 名称到 Ant Design 图标的映射
 *
 * 后端返回的 icon 字段是字符串（如 "LayoutDashboard"），
 * 需要映射为 Ant Design 图标组件供 ProLayout 使用。
 *
 * 使用方式：在 menu-builder.ts 的 toProLayoutMenuData 中调用 getMenuIcon(name)
 */

import * as AntdIcons from '@ant-design/icons';
import React from 'react';

/**
 * 根据 icon 名称获取 Ant Design 图标组件
 *
 * 匹配规则（按优先级）：
 * 1. 精确匹配（如 "SmileOutlined"）
 * 2. 加 Outlined 后缀匹配（如 "Smile" → "SmileOutlined"）
 * 3. 首字母大写后匹配（如 "smile" → "SmileOutlined"）
 * 4. 未匹配返回 undefined
 */
export function getMenuIcon(name?: string): React.ReactNode | undefined {
  if (!name) return undefined;

  const icons = AntdIcons as Record<string, any>;

  // 精确匹配
  if (icons[name]) {
    return React.createElement(icons[name]);
  }

  // 加 Outlined 后缀
  const withOutlined = `${name}Outlined`;
  if (icons[withOutlined]) {
    return React.createElement(icons[withOutlined]);
  }

  // 首字母大写
  const capitalized = name.charAt(0).toUpperCase() + name.slice(1);
  if (icons[capitalized]) {
    return React.createElement(icons[capitalized]);
  }
  const capitalizedOutlined = `${capitalized}Outlined`;
  if (icons[capitalizedOutlined]) {
    return React.createElement(icons[capitalizedOutlined]);
  }

  return undefined;
}
